import React from 'react';
import PropTypes from 'prop-types';

import {Commands as ModuleCommands} from 'views/module';

import {simplifyQuestions} from 'utils/user_bio';

const SlashCommands = (props) => {
  const {caregiverBackend, caregiverBioQuestions, caregiverRn, caregiverData} = props;

  const caregiverBio = React.useMemo(() => {
    if (!caregiverBioQuestions?.questions) {
      return {};
    }

    return simplifyQuestions(caregiverBioQuestions.questions);
  }, [caregiverBioQuestions]);

  const slashCommandProps = React.useMemo(() => {
    const email = caregiverBio.email;
    const phoneNumber = caregiverBio.phoneNumber;
    const defaultRelationship = {
      relationshipRn: caregiverRn,
      name: caregiverData.caregiverName,
      email,
      phoneNumber,
    };
    const [firstName, ...lastNameParts] = caregiverData.caregiverName.split(' ');

    return {
      communicationTarget: {
        defaultRelationship,
        email,
        getRelationshipEmail: (relationship) => relationship?.email || '',
        getRelationshipSms: (relationship) => relationship?.phoneNumber || '',
        relationships: [defaultRelationship],
        sendEmail: async (emailData, _relationshipRn, onSuccess, onError=()=>undefined) => {
          return caregiverBackend.messages.sendEmail(caregiverRn, emailData, onSuccess, onError);
        },
        sendSms: async (smsData, _requester, _relationshipRn, onSuccess, onError=()=>undefined) => {
          return caregiverBackend.messages.sendSms(
              caregiverRn,
              smsData.message,
              smsData.fromEmail,
              onSuccess,
              onError,
          );
        },
      },
      resources: [
        {type: 'CAREGIVER', rn: caregiverRn, firstName, lastName: lastNameParts.join(' ')},
      ],
      playbook: {
        execute: async (playbookRn, resourceRns) => {
          await caregiverBackend.playbooks.execute(playbookRn, resourceRns);
        },
      },
    };
  }, [caregiverBackend, caregiverBio, caregiverData, caregiverRn]);

  return (
    <ModuleCommands
      {...slashCommandProps}
    />
  );
};

SlashCommands.propTypes = {
  caregiverBackend: PropTypes.object.isRequired,
  caregiverBioQuestions: PropTypes.object.isRequired,
  caregiverRn: PropTypes.string.isRequired,
  caregiverData: PropTypes.object.isRequired,
};

export default React.memo(SlashCommands);
